import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Card, Divider } from 'antd';
import { UserOutlined, LockOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './Login.scss';
import config from '../../config.json';
import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import BaseFooter from '../Footer/BaseFooter';
import ResetPwCard from './ResetPwCard';
import { URL_USERS } from '../../service/endpoints';
import axios from 'axios';
import { useNotification } from '../../Helper/NotificationProvider';

export default function ResetPwdPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [forgotPw, setForgotPw] = useState(false);
  const { openNotification, contextHolder } = useNotification();

  const handleClose = () => {
    navigate('/login');
  };

  const handleForgotPw = () => {
    setForgotPw(true);
  };

  const onFinish = values => {
    postResetPwd(values.password, values.confirm);
  };

  // Get the userId and token from the query parameters
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userId = params.get('userId');
  const token = params.get('token');
  const verify = params.get('verify');

  const postResetPwd = async (password, confirm) => {
    try {
      if (
        password !== '' &&
        confirm !== '' &&
        password === confirm &&
        userId !== '' &&
        token !== ''
      ) {
        const authBody = {
          password: password
        };

        if (verify === 'true') {
          authBody.verified = true;
        }

        let config = {
          method: 'patch',
          maxBodyLength: Infinity,
          url: URL_USERS + '/' + userId,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
          },
          data: authBody
        };
        await axios.request(config)
        navigate('/login')
        openNotification(
          'bottomRight',
          'Erfolg',
          'Passwort wurde erfolgreich zurückgesetzt.',
          true
        );
      }
    } catch (err) {
      openNotification(
        'bottomRight',
        'Fehler',
        'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut.',
        false
      );
      console.log(err);
    }
  };

  return (
    <div className="container">
      <header className="app-header">
        <img src={config.resetPw.image} alt="Logo" />
        {!config.resetPw.active && (
          <div className="close-btn">
            <Button
              shape="circle"
              type="primary"
              onClick={handleClose}
              icon={<CloseOutlined />}
              size={'large'}
              className="close-login-btn"
            />
          </div>
        )}
      </header>
      <div className="card-login">
        <p className="title">
          {verify ? 'Account verifizieren' : 'Passwort zurücksetzen'}
        </p>
        {
          <ResetPwCard
            translation={t}
            setLanguage={setLanguage}
            setForgotPw={setForgotPw}
            onFinish={onFinish}
            handleForgotPw={handleForgotPw}
            language={language}
          />
        }
      </div>
      {/* <BaseFooter /> */}
    </div>
  );
}
